//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  let x, lastHourIntval
  import {
    mapState,
    mapMutations
  } from 'vuex'
  import Menu from '../../components/menu/Menu.vue'
  import MenuMb from '../../components/menu/MenuMb.vue'
  import {
    campaignMenu,
    campaignInfo,
    campaignGoods,
    getCartNum,
    checkSession
  } from '../../service/index'
  import {
    pushChildren
  } from '../../utils/storage'
  import moment from 'moment'
  export default {
    data() {
      return {
        navMenu: [],
        campaignInfo: {},
        currentActivityEnd: false,
        minutes: '',
        seconds: '',
        showCount: false
      }
    },
    components: {
      Menu,
      MenuMb
    },
    created() {
      this.keepLang()
      // this.initFromStore();
      //this.getMenu();
    },
    computed: {
      ...mapState([
        'global', 'campaign'
      ])
    },
    mounted() {
      this.getMenu();

      const camId = this.$route.params.id || this.$route.query.cid

      // checkSession(camId).then((res) => {
      //   if (res.data) {
      //     let dateTime = new Date().getTime()
      //     //console.log(moment(res.data.end).format('YYYY-MM-DD HH:mm:ss'))
      //     let hours = moment(res.data.end).diff(moment(), 'hours');
      //     // console.log('hours', hours)
      //     // console.log('hours',hours)
      //     if (hours <= 1 && hours>=0) {
      //       this.showCountDown(res.data.end)
      //       //lastHourIntval && clearInterval(lastHourIntval)
      //     } else {
      //       //console.log('hours',hours)
      //       if(hours<0){
      //         return false
      //       }
      //       lastHourIntval = setInterval(() => {
      //         checkSession(camId).then((res) => {
      //           if (res.data) {
      //             let dateTime = new Date().getTime()
      //             //console.log(moment(res.data.end).format('YYYY-MM-DD HH:mm:ss'))
      //             let hours = moment(res.data.end).diff(moment(), 'hours');
      //             //console.log('hours', hours)
      //            if (hours <= 1 && hours>=0) {
      //               this.showCountDown(res.data.end)
      //                clearInterval(lastHourIntval)
      //             }
      //           } else {
      //             clearInterval(lastHourIntval)
      //           }
      //         })

      //       }, 3000)

      //     }
      //   } else {
      //     //lastHourIntval &&  clearInterval(lastHourIntval)
      //   }
      // })




    },
    activated() {},
    watch: {
      $route(to, from) {
        if (from.query.cid !== to.query.cid) {
          this.navMenu = []
          this.getMenu();
        }
      }
    },
    methods: {
      ...mapMutations({
        saveCampaignInfo: 'INIT_CAMPAIGN',
        initMenu: 'INIT_MENU',
        initFromStore: 'INIT_CAMPAIGN_STORE',
        initCartNum: 'INIT_CART_NUM',
        initGoods: 'INIT_GOODS'
      }),
      async getMenu() {
        const camId = this.$route.params.id || this.$route.query.cid
        const responseCampaign = await campaignInfo(camId);
        if (responseCampaign.data) {
          //this.campaignInfo



          this.saveCampaignInfo(responseCampaign.data)
          const menu = await campaignMenu(camId);
          if (menu.status == -3) {
            this.currentActivityEnd = true
          }
          const parent = menu.data.types || [];
          const children = menu.data.cats || [];
          pushChildren(parent, children)
          this.navMenu = parent;
          this.initMenu(parent);
          const cartNum = await getCartNum(camId)
          this.initCartNum({
            cartNum: cartNum.data
          })
        }
      },
      showCountDown(end) {
        this.showCount = true
        var countDownDate = moment(end)
        var that = this
        x = setInterval(function () {
          var now = new Date().getTime();
          var distance = countDownDate - now + 1000;
          // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          ///var hours = Math.floor((distance ) / (1000 * 60 * 60));
          var minutes = Math.floor((distance) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          //hours = hours < 10 ? "0" + hours : hours;
          that.minutes = minutes < 10 ? "0" + minutes : minutes;
          that.seconds = seconds < 10 ? "0" + seconds : seconds;
          if (distance <= 1000) {
            clearInterval(x);
            //window.location.reload();
          }
        }, 1000);
      },
      keepLang() {
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
      },
    }
  }



// WEBPACK FOOTER //
// ./src/pages/nav/Nav.vue